module.exports = __webpack_public_path__ + "static/media/pass_failed.6163ae43.svg";